<template>
  <div class="upload_wrapper">
    <el-upload
      class="avatar-uploader"
      :data={folderName}
      :action="uploadAddr + 'upload/uploadpic'"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload">
      <div v-if="picUrl" class="pic">
        <img :src="$store.getters.uploadAddr+picUrl">
      </div>
      <div v-else class="choose">
        <i></i>
        <div class="text">{{text}}</div>
      </div>
    </el-upload>
  </div>

</template>
<script>
  // import {mapGetters} from 'vuex'

  export default {
    props: {
      folderName: {},
      picUrl: {
        default: ''
      },
      text: {
        default: ''
      },
      width: {
        default: ''
      },
      height: {
        default: 120
      }
    },
    data () {
      return {
        picAddr: '',
        imageUrl: this.picUrl?this.uploadAddr+this.picUrl: ''
      }
    },
    watch: {
      picUrl (val1,val2) {
        if (val1) {
          this.imageUrl = this.uploadAddr+val1
        }
      }
    },
    created () {
    },
    activated() {
      if (this.picUrl) {
        this.imageUrl = this.uploadAddr+this.picUrl
      } else {
        this.imageUrl = ''
      }
    },
    methods: {
      handleAvatarSuccess (res, file) {
        console.log(file, 900)
        this.imageUrl = file.response
        this.$emit('changed', this.imageUrl.replace(this.uploadAddr, ''),file.name,file.uid)
      },
      beforeAvatarUpload (file) {
        let isJPG = false
        if (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg') {
          isJPG = true
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isJPG) {
          // this.$message.error('上传图片只能是 JPG 格式!')
        }
        if (!isLt2M) {
          // this.$message.error('上传图片大小不能超过 2MB!')
        }
        return isJPG && isLt2M
      }
    },
    computed: {
      headers () {
        return {
          Authorization: 'Bearer ' + window.localStorage.getItem('token')
        }
      },
      uploadAddr() {
        return this.$store.getters.uploadAddr
      }
      // ...mapGetters(['picAddr'])
    }

  }
</script>
<style lang="scss" scoped>
  .upload_wrapper {
    .pic {
      width: 80%;
      /*height: 150px;*/
    }

    .pic img {
      max-height: 160px;
      max-width: 100%;
    }

    .choose {
      display: flex;
      flex-direction: column;
      align-items: center;
      i {
        display: block;
        width: 42px;
        height: 43px;
        background-size: 42px 43px;
        background-image: url("../../assets/image/icon_plus.png");
      }
      .text {
        padding-top: 5px;
      }
    }
  }
</style>

